import { MOCK_CERTIFICATE_INVALID_PASSWORD } from "../constants/infraction-certificate.constant";
import type {
	CertificateFormErrors,
	CertificateFormValues,
} from "../types/infraction-certificate.types";

const PFX_EXTENSION = /\.(pfx|p12)$/i;

export function validateCertificateForm(
	values: CertificateFormValues
): CertificateFormErrors {
	const errors: CertificateFormErrors = {};

	if (!values.certificateFile) {
		errors.certificate = "Envie o certificado digital (.PFX ou .P12).";
	} else if (!PFX_EXTENSION.test(values.certificateFile.name)) {
		errors.certificate = "Formato inválido. Use apenas arquivos .PFX ou .P12.";
	}

	if (!values.certificatePassword.trim()) {
		errors.certificatePassword = "Informe a senha do certificado.";
	} else if (values.certificatePassword === MOCK_CERTIFICATE_INVALID_PASSWORD) {
		errors.certificatePassword = "Senha incorreta";
	}

	return errors;
}

export function hasCertificateFormErrors(
	errors: CertificateFormErrors
): boolean {
	return Object.keys(errors).length > 0;
}
